import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/auth/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/prijava',
        name: 'login',
        meta: { permissions: [] },
        component: Login
    },
    {
        path: '/odjava',
        name: 'logout',
        meta: { permissions: [] },
        component: () => import('@/views/auth/Logout.vue')
    },
    {
        path: '/ponastavitev-gesla',
        name: 'passwordResetRequest',
        meta: { permissions: [] },
        component: () => import('@/views/auth/PasswordResetRequest.vue')
    },
    {
        //path: '/ponastavitev-gesla/:token',
        path: '/password-reset/:token',
        name: 'passwordReset',
        meta: { permissions: [] },
        component: () => import('@/views/auth/PasswordReset.vue')
    }, 
    /* ERRORS */
    {
        path: '*',
        name: '404',
        meta: { permissions: [] },
        component: () => import('@/views/errors/404.vue')
    },
    {
        path: '/403',
        name: '403',
        meta: { permissions: [] },
        component: () => import('@/views/errors/403.vue')
    },
    {
        path: '/500',
        name: '500',
        meta: { permissions: [] },
        component: () => import('@/views/errors/500.vue')
    },

    {
        path: '/',
        component: () => import('@/views/RootView.vue'),
        children: [
            {
                path: 'pregled',
                name: 'dashboard' ,
                component: () => import('@/views/Dashboard.vue'),
                alias: '',
                meta: { requiresAuth: true, permissions: ['sobec-view-events']}
            },
            {
                path: 'nastavitve',
                name: 'settings',
                component: () => import('@/views/Settings.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-settings', 'sobec-update-settings'] }
            },

            {
                path: 'clanarina/seznam-placil',
                name: 'membership_fee_payments',
                component: () => import('@/views/MembershipFeePayments.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-membership-fee-payment'] }
            },

            {
                path: 'clanarina/dodaj-placilo',
                name: 'add_membership_fee_payment',
                component: () => import('@/views/AddMembershipFeePayment.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-create-membership-fee-payment'] }
            },



            // ČLANI
            {
                path: 'clani/seznam-clanov',
                name: 'members_list',
                component: () => import('@/views/Members.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-member', 'sobec-create-Member']}
                
            },
            {
                path: 'clani/dodaj-clana',
                name: 'add_member',
                component: () => import('@/views/AddMember.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-create-member']}
            },
            {
                path: 'clani/seznam-clanov/:id',
                name: 'edit_member',
                component: () => import('@/views/EditMember.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-update-member']}
            },

            {
                path: 'clani/seznam-clanov/:id/pogled',
                name: 'view_member',
                component: () => import('@/views/ViewMember.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-member']}
            },


            // UPORABNIKI
            {
                path: 'uporabniki/seznam-uporabnikov',
                name: 'users_list',
                component: () => import('@/views/Users.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-user', 'sobec-create-user']}
                
            },
            {
                path: 'uporabniki/dodaj-uporabnika',
                name: 'add_user',
                component: () => import('@/views/AddUser.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-create-user']}
            },
            {
                path: 'uporabniki/seznam-uporabnikov/:id',
                name: 'edit_user',
                component: () => import('@/views/EditUser.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-update-user']}
            },

            {
                path: 'uporabniki/seznam-uporabnikov/:id/pogled',
                name: 'view_user',
                component: () => import('@/views/ViewUser.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-user']}
            },

            /*{
                path: 'najave/seznam-najav',
                name: 'announcement_list',
                component: () => import('@/views/Announcements.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-announcement', 'sobec-create-announcement']}
            },
            {
                path: 'najave/dodaj-najavo',
                name: 'add_announcement',
                component: () => import('@/views/AddAnnouncement.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-create-announcement']}
            },
            {
                path: 'najave/seznam-najav/:id',
                name: 'edit_announcement',
                component: () => import('@/views/EditAnnouncement.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-update-announcement']}
            },

            {
                path: 'najave/seznam-najav/:id/pogled',
                name: 'view_announcement',
                component: () => import('@/views/ViewAnnouncement.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-view-announcement']}
                
            },*/

            {
                path: 'enkratni-prehodi/registrske-stevilke',
                name: 'registration-numbers',
                component: () => import('@/views/RegistrationNumbers.vue'),
                //alias: '',
                meta: { requiresAuth: true, permissions: ['sobec-view-registration-number']}
            },

            /*{
                path: 'zasedenost-parkirisca',
                name: 'parking_occupancy',
                component: () => import('@/views/ParkingOccupancy.vue'),
                //alias: '',
                meta: { requiresAuth: true, permissions: ['sobec-view-parking-occupancy']}
            },*/
            
            /*{
                path: 'semaforji',
                name: 'traffic_lights',
                component: () => import('@/views/TrafficLights.vue'),
                meta: { requiresAuth: true}
            },*/

            {
                path:'zapornice/upravljanje',
                name: 'parking_barriers_management',
                component: () => import('@/views/ParkingBarriers.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-parking-barriers'] }
            },

            {
                path:'zapornice/arhiv',
                name: 'parking_barriers_archive',
                component: () => import('@/views/ParkingBarriersArchive.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-parking-barriers'] }
            },

            {
                path:'izvoz-podatkov',
                name: 'exports',
                component: () => import('@/views/Exports.vue'),
                meta: { requiresAuth: true, permissions: ['sobec-data-export'] }
            },

            //test print
            {
                path:'print',
                name: 'print',
                component: () => import('@/views/Print.vue'),
                meta: { requiresAuth: true, permissions: [] }
            }
        ]
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    },
    linkActiveClass: 'v-list__tile--active router-link-active active',
    routes
})

export default router